export default __webpack_public_path__ + "static/media/seller-order.44f52494.png";